import { useEffect, useState } from 'react'
import { Props } from './Layout'
import { useWithdrawAkvMutation } from './query.generated'
import { AKVWei, akvToWeiAKV, extractNumbers } from '@/src/services/AKVService'
import { useLoginUser } from '../../states/LoginUser'
import { AKV__factory } from '@victgame/akiverse-ft-contracts'
import { MetamaskService } from '@/src/services/MetamaskService'
import { useMetamaskWalletAddress } from '../../states/MetamaskWalletAddress'

export type Params = { onComplete: () => Promise<void>; onClickClose: () => void }

export const useProps = ({ onComplete, onClickClose }: Params): Props => {
  const [visibleLoading, setVisibleLoading] = useState(false)
  const [amount, setAmount] = useState('')
  const [withdrawAkvMutation] = useWithdrawAkvMutation()
  const [akvWalletBalance, setAkvWalletBalance] = useState<AKVWei | undefined>(undefined)
  const loginUser = useLoginUser().loginUser
  const akvBalance = loginUser?.akvBalance
  const address = loginUser?.walletAddress
  const currentMetamskWalletAddress = useMetamaskWalletAddress().walletAddress

  useEffect(() => {
    // 保有しているAKVを取得
    currentMetamskWalletAddress &&
      currentMetamskWalletAddress === address &&
      new AKV__factory()
        .attach(process.env.NEXT_PUBLIC_AKV_CONTRACT_ADDRESS)
        .connect(MetamaskService.getSigner())
        .balanceOf(address!)
        .then((balanceOf) => setAkvWalletBalance(new AKVWei(balanceOf.toString())))
  }, [address, currentMetamskWalletAddress])

  return {
    akvBalance: Number(akvBalance?.toAKV()),
    amount,
    visibleLoading,
    walletBalance: akvWalletBalance?.toAKV() ?? '',
    inAkiverseBalance: akvBalance?.toAKV() ?? '',
    onUpdateAmount: (value: string) => setAmount(extractNumbers(value)),
    onClickMax: () => setAmount(Number(akvBalance?.toAKV()).toFixed() ?? ''),
    onClickWithdraw: async () => {
      setVisibleLoading(true)
      try {
        const result = await withdrawAkvMutation({
          variables: { input: { amount: akvToWeiAKV(amount).toString() } },
        })
        if (result.errors) {
          alert(result.errors?.[0]?.message || 'Error')
          return
        }

        await onComplete()
        setVisibleLoading(false)
      } catch (e: any) {
        alert((e?.errors ? e.errors?.[0]?.message : e?.message) || 'Error')
        setVisibleLoading(false)
      }
    },
    onClickClose,
  }
}
